import { BasketItemQuoteDetails } from '@basket';
import { ClientBrandCode } from '@common';
import { SelectedApplianceDetails } from '@features/multi-plan';
import { format, parse } from 'date-fns';

export function formatSelectedApplianceDetailsToBasketBrandList(
  initialApplianceClientBrandCode: ClientBrandCode,
  selectedAppliancesDetails: SelectedApplianceDetails[],
): string {
  return selectedAppliancesDetails.reduce<string>((acc, appliance, index) => {
    const applianceNumber = index + 2;
    return `${acc}, appliance ${applianceNumber}: ${appliance.manufacturer}`;
  }, `appliance 1: ${initialApplianceClientBrandCode}`);
}

export function formatSelectedApplianceDetailsToBasketDateOfPurchaseList(
  initialApplianceDateOfPurchase: string,
  selectedAppliancesDetails: SelectedApplianceDetails[],
): string {
  const parsedDate = parse(
    initialApplianceDateOfPurchase,
    'MMMM yyyy',
    new Date(),
  );
  const formattedFirstApplianceDateOfPurchase = format(parsedDate, 'MMMM yyyy');
  const firstIndex = 1;
  const initialAppliance = `appliance ${firstIndex}: ${formattedFirstApplianceDateOfPurchase}`;
  const currentYear = new Date().getFullYear();

  const selectedAppliancesFormatted = selectedAppliancesDetails
    .map(
      (appliance: SelectedApplianceDetails, index: number) =>
        `appliance ${firstIndex + 1 + index}: ${format(new Date(currentYear, (appliance.purchaseMonth as number) - 1), 'MMMM')} ${appliance.purchaseYear}`,
    )
    .join(', ');

  return `${initialAppliance}, ${selectedAppliancesFormatted}`;
}

export function formatSelectedApplianceDetailsToBasketProductNameList(
  initialApplianceName: string,
  selectedAppliancesDetails: SelectedApplianceDetails[],
): string {
  return selectedAppliancesDetails.reduce<string>((acc, appliance, index) => {
    const applianceNumber = index + 2;
    return `${acc}, appliance ${applianceNumber}: ${appliance.applianceName}`;
  }, `appliance 1: ${initialApplianceName}`);
}

export function formatSelectedApplianceDetailsToBasketPurchaseCostList(
  initialApplianceCost: number,
  selectedAppliancesDetails: SelectedApplianceDetails[],
): string {
  return selectedAppliancesDetails.reduce<string>((acc, appliance, index) => {
    const applianceNumber = index + 2;
    return `${acc}, appliance ${applianceNumber}: ${appliance.purchasePrice}`;
  }, `appliance 1: ${initialApplianceCost}`);
}

export function formatPlanTermFromQuote(quote: BasketItemQuoteDetails): string {
  return quote.periodOfCover === 24 || quote.periodOfCover === 48
    ? `${quote.periodOfCover / 12} years`
    : 'monthly';
}
